// External utility packages
import _currency from "currency.js";
import { validate as _isValidEmail } from "email-validator";
import * as _cookies from "js-cookie";

export const currency = _currency;
export const isValidEmail = _isValidEmail;
export const cookies = _cookies;

// Local utilities
export { retry } from "./retry";
export * from "./isAndroidWebView";
export { isTouchDevice } from "./isTouchDevice";
export { hideOnAndroidWebView } from "./hideOnAndroidWebView";
export { parseQueryString } from "./parseQueryString";
export { serializeQueryString } from "./serializeQueryString";
export { urlUpdate } from "./urlUpdate";
export { updateQueryParams } from "./updateQueryParams";
export { getEncodedUrl } from "./getEncodedUrl";
export { getEffectiveUrl } from "./getEffectiveUrl";
export { removeProperty } from "./removeProperty";
export { isMobileUA } from "./isMobileUA";
export * from "./formatPrice";
export { getCookie } from "./getCookie";
export { getSalesChannel } from "./getSalesChannel";
export { localStorage, sessionStorage } from "./localStorage";
export * from "./hooks";
export { resizeImage } from "./image";
export { isSoldByCatch } from "./isSoldByCatch";
export { getAlternateUrl, getCanonicalUrl, cleanHostName } from "./seo";
export * from "./regex";
export * from "./pluralize";
export * from "./path";
export * from "./isIE";
export * from "./minusOnePx";
export { isClientError } from "./http";
export { encodeSearchTerm } from "./encodeSearchTerm";
export * from "./promise";
